{
    "grid-border-color":"#e9e9e9",
    "grid-header-bg-color": "#265728",
    "grid-header-font-color": "#ffffff",
    "grid-cell-text-align":"center",
    "grid-row-hover-bg-color": "#95d097",
    "grid-row-active": "#84c886",
    "grid-row-alternate": "#edf7ee",
    "grid-footer-bg-color": "#3d8b40",
    "grid-footer-font-color": "#ffffff",
    "grid-cell-font-color": "#303030",
    "grid-checkbox-bg-color": "#3d8b40",
    "tile-border-color":"#e9e9e9",
    "tile-bg-color": "#265728",
    "tile-font-color": "#ffffff",
    "tile-hover-bg-color": "#3e8e41",
    "header-bg-color": "#265728",
    "header-ico-active-color": "#3e8e41",
    "title-font-color": "#265728",
    "login-ico-color": "#265728",
    "button-primary-bg-color": "#265728",
    "button-primary-hover-bg-color": "#3e8e41",
    "button-secondary-bg-color": "#009999",
    "button-secondary-hover-bg-color": "#009999",
    "button-secondary-font-color": "#ffffff",
    "object-ico-color": "#265728",
    "object-ico-active-color": "#3e8e41"
}